import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { ActivatedRoute, Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { Observable } from 'rxjs';
import { PayoutDialog } from '@components/payout.dialog';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@environments/environment';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'withdraw-bank-wettarena-component',
  templateUrl: './withdraw-bank-wettarena.component.html',
})
export class WithdrawBankWettarenaComponent {
  MinValue = 0;
  MaxValue = 0;

  banksDatas: UntypedFormGroup;
  banksDatasRaw: any;

  bank: { BankId: number; Bank: string };
  // bankList = [];
  @Output() dataChangedCallback = new EventEmitter<any>();

  bankList: { BankId: number; Bank: string }[] = [];

  myControl = new UntypedFormControl();
  options;
  filteredOptions: Observable<string[]>;

  constructor(
    public dialogRef: MatDialogRef<WithdrawBankWettarenaComponent>,
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.route.params.subscribe(params => {
      this.getWithDrawInfo();
    });

    this.banksDatas = _FormBuilder.group({
      bankList: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      accountNo: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      nameSurname: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      // ssn: new FormControl({ value: '', disabled: false }),
      banksAmount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.min(this.MinValue), Validators.max(this.MaxValue)]),
    });
  }

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();

    this._UiHelper.setNavbarTitle('Withdraw', true);
    this.WithdrawBanks();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  WithdrawBanks() {
    this._ApiService.getWithdrawBanks().then(result => {
      this.bankList = result;
    });
  }

  openPayoutDialog(): void {
    const dialogRef = this.dialog.open(PayoutDialog, {
      width: environment.mobile ? '340px' : '500px',
      height: environment.mobile ? '345px' : '240px',
    });
    dialogRef.afterClosed().subscribe(result => {
      // //console.log('The dialog was closed',result);
    });
  }

  getWithDrawInfo() {
    this._ApiService.getWithDrawDepositControl3().then(result => {
      //console.log("getDeposit--",result.filter(item => item.DepositTypeId == this.DepositTypeId));

      const WithDrawInfo = result;

      this.MinValue = WithDrawInfo[0].MinValue;
      this.MaxValue = WithDrawInfo[0].MaxValue;
      console.warn('WithDrawInfo[0].MinValue', WithDrawInfo[0].MinValue, WithDrawInfo[0].MaxValue);
      if (WithDrawInfo.length > 0) {
        this.banksDatas.controls.bankList.setValue('');
        this.banksDatas.controls.accountNo.setValue('');
        this.banksDatas.controls.nameSurname.setValue(this._UserHelper.customerUser.CustomerName + ' ' + this._UserHelper.customerUser.CustomerSurname.split('-')[0]);
        // this.banksDatas.controls.ssn.setValue("");
        this.banksDatas.controls.banksAmount.setValidators([Validators.required, Validators.min(this.MinValue), Validators.max(this.MaxValue)]);
        if (this.data.amount) {
          this.banksDatas.controls.banksAmount.setValue(this.data.amount);
        }

        // this.banksDatas = this._FormBuilder.group({
        //   bankList: new FormControl({ value: '', disabled: false }, [Validators.required]),
        //   accountNo: new FormControl({ value: '', disabled: false }, [Validators.required]),
        //   nameSurname: new FormControl({ value: '', disabled: false }, [Validators.required]),
        //   ssn: new FormControl({ value: '', disabled: false }),
        //   banksAmount: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(5), Validators.min(this.MinValue), Validators.max(this.MaxValue)])
        // });
        this.banksDatas.valueChanges.subscribe(x => {
          this.banksDatasRaw = x;
          if (x.bankList == '') {
            this.WithdrawBanks();
          }
          this.bankList = this.bankList.filter(option => option.Bank !== null && option.Bank.toLowerCase().includes(x.bankList.toLowerCase()));
        });
      }
    });
  }

  submitBanksData() {
    console.warn('this.MinValue,this.MaxValue', this.MinValue, this.MaxValue);
    console.warn('valid', this.validIban(this.banksDatas.controls.accountNo.value));
    console.warn('banksDatas', this.banksDatas, this.banksDatas.valid);
    if (this.validIban(this.banksDatas.controls.accountNo.value)) {
      this._UiHelper.setLoadingDialog(true);
      this._ApiService.withdrawBanks(this.banksDatasRaw, this.bankList[0].BankId).then(result => {
        this._UiHelper.setLoadingDialog(false);
        const translator = new TranslatePipe(this._LocalizationService);
        this._UiHelper.setLoadingDialog(false);

        if (result.code == '') {
          //return "error|System Error";
        } else {
          if (result.code == 'error') {
            this._UiHelper.errorSnackBar(result.message, '');
          } else if (result.code == 'errorcode') {
            let t_message = translator.transform(result.message, null);
            t_message = t_message + ' : ' + result.description;
            this._UiHelper.errorSnackBar(t_message, '');
          } else if (result.code == 'success') {
            //window.location = result.message;

            let t_message = translator.transform(result.message, null);
            t_message = t_message + result.description;
            this._UiHelper.successSnackBar(t_message, '');

            this.openPayoutDialog();

            this._ApiService
              .getClient2()
              .then(result => {
                this._UserHelper.setUser(result);
              })
              .catch();
          }
          this.dataChangedCallback.emit(true);
        }
      });
    } else {
      const t_message = 'İban is not valid';

      this._UiHelper.errorSnackBar(t_message, '');
    }
  }

  validIban(value: any) {
    const rearrange = value.substring(4, value.length) + value.substring(0, 4);
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    const alphaMap = {};
    const number = [];

    alphabet.forEach((value, index) => {
      alphaMap[value] = index + 10;
    });

    rearrange.split('').forEach((value, index) => {
      number[index] = alphaMap[value] || value;
    });

    return this.modulo(number.join('').toString(), 97) === 1;
  }

  modulo(aNumStr, aDiv) {
    let tmp: any = '';
    let i, r;
    for (i = 0; i < aNumStr.length; i++) {
      tmp += aNumStr.charAt(i);
      r = tmp % aDiv;
      tmp = r.toString();
    }
    return tmp / 1;
  }
}
